/**
 * Created by mslobozeanu on 5/17/2017.
 */

/**
 * @class TS.domain.properties.AdaptiveSearchProperty
 * @extends TS.domain.properties.AdaptiveLookupProperty
 */
var AdaptiveSearchProperty = TS.domain.properties.AdaptiveSearchProperty = new Class(
    /** @lends TS.domain.properties.AdaptiveSearchProperty# */
    {
        Extends: TS.domain.properties.AdaptiveLookupProperty,
        //keywordField

        initialize: function (domain, config) {
            var me = this;
            me.KeywordMember = config.ListMember;
            me.parent(domain, config);
        },

    });

TS.domain.properties.SearchListProperty.mixin(AdaptiveSearchProperty);

TS.ObjectFactory.map('AdaptiveSearchProperty', AdaptiveSearchProperty);
